import { render, staticRenderFns } from "./ModalProductLabelListItem.vue?vue&type=template&id=05823dfa&scoped=true&"
import script from "./ModalProductLabelListItem.vue?vue&type=script&lang=js&"
export * from "./ModalProductLabelListItem.vue?vue&type=script&lang=js&"
import style0 from "./ModalProductLabelListItem.vue?vue&type=style&index=0&id=05823dfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05823dfa",
  null
  
)

export default component.exports